import { InjectionToken } from "@angular/core";
import { TablePagingService } from "../classes/table-paging-service";

export const TABLE_PAGING_SERVICE = new InjectionToken<TablePagingService<object>>("TablePagingService");
